import {
    Box,
    Grid,
    Flex,
    GridItem,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Text,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    Link,
} from '@chakra-ui/react';
import type { SubscriptionInfo, HeaderInfo, DetailsInfo } from './TableSectionWithNav';
import { StyledBox } from './styles';
import React, { useState, useRef } from 'react';
import { CheckIcon } from '@chakra-ui/icons';
import DOMPurify from 'dompurify';

interface Props {
    valuesName: { [key: string]: string };
    valuesNameMobile: { [key: string]: string };
    mainCategories: { [key: string]: string };
    tableSection: SubscriptionInfo[];
    columns: Number;
    isOpenAll?: Boolean;
    isBlocked?: Boolean;
    headerValues: HeaderInfo[];
}

export const TableSectionMobileWithNav = ({
    tableSection,
    mainCategories,
    valuesName,
    columns,
    isOpenAll,
    isBlocked,
    headerValues,
    valuesNameMobile,
}: Props) => {
    const allowMultiple = isOpenAll ? true : undefined;

    const [tabIndex, setTabIndex] = useState(0);
    const [openAccordions, setOpenAccordions] = useState<number[]>([]);
    const tableMobileRef = useRef<HTMLDivElement>(null);

    const handleTabsChange = (index: number) => {
        setTabIndex(index);
        setOpenAccordions([]); // Reset open accordions when tab changes
        if (tableMobileRef.current) {
            setTimeout(() => {
                if (tableMobileRef.current) {
                    // Dodatkowa kontrola wewnątrz setTimeout
                    const y =
                        tableMobileRef.current.getBoundingClientRect().top +
                        window.pageYOffset -
                        80;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            }, 0);
        }
    };

    const handleAccordionChange = (expandedIndex: number | number[]) => {
        setOpenAccordions(Array.isArray(expandedIndex) ? expandedIndex : [expandedIndex]);
    };

    return (
        <Box
            id="table_mobile"
            // marginLeft={'calc((100vw - 95%) / -2)'}
            // marginRight={'calc((100vw - 95%) / -2)'}
            marginLeft={'-2.5vw'}
            marginRight={'-2.5vw'}
            ref={tableMobileRef}
        >
            <Tabs index={tabIndex} onChange={handleTabsChange} variant="unstyled">
                <Box position="sticky" top={'55px'} zIndex={1} bg="white">
                    <TabList width="100%">
                        {Object.entries(valuesNameMobile).map(([key, value], index, array) => {
                            const isLastItem = index === array.length - 1;
                            return (
                                <Tab
                                    key={key}
                                    _selected={{
                                        '&::after': {
                                            content: '""',
                                            position: 'absolute',
                                            top: '-1px',
                                            left: '-1px',
                                            height: '2px',
                                            background: '#1AAC7A',
                                            right: isLastItem ? '0' : '-1px',
                                        },
                                    }}
                                    _focus={{ boxShadow: 'none' }}
                                    fontSize="18px"
                                    fontWeight="600"
                                    width="auto"
                                    flexGrow={'1'}
                                    py={2}
                                    color={'#1AAC7A'}
                                    bg={index === tabIndex ? '#d4f7e5' : 'white'}
                                    borderBottom={
                                        index === tabIndex
                                            ? '1px solid #d4f7e5'
                                            : '1px solid #EEEEEE'
                                    }
                                    boxSizing="content-box"
                                    borderTop={'1px solid #EEEEEE'}
                                    position={'relative'}
                                    borderRight={isLastItem ? 'none' : '1px solid #EEEEEE'}
                                    padding="12px 15px"
                                >
                                    {value}
                                </Tab>
                            );
                        })}
                    </TabList>
                </Box>

                <TabPanels>
                    {headerValues.map((headerValue: HeaderInfo, i) => {
                        const values = [...Object.keys(valuesName).map(mainCat => mainCat)];
                        const type = headerValue.type ? headerValue.type : false;
                        return (
                            <TabPanel key={values[i]} padding={'0'}>
                                <StyledBox
                                    padding={'20px 30px 30px'}
                                    display={'flex'}
                                    flexDirection={'column'}
                                    justifyContent={'space-between'}
                                >
                                    <Text
                                        fontWeight={'700'}
                                        fontSize={'16px'}
                                        lineHeight={'1.56'}
                                        marginBottom={'15px'}
                                    >
                                        {headerValue.title}
                                    </Text>
                                    <Box>
                                        {headerValue.priceTop && (
                                            <Text
                                                fontWeight={'600'}
                                                fontSize={'18px'}
                                                lineHeight={'normal'}
                                                color={headerValue.priceColor ?? 'inherit'}
                                            >
                                                {headerValue.priceTop}
                                            </Text>
                                        )}
                                        <Text
                                            fontWeight={'600'}
                                            fontSize={'34px'}
                                            lineHeight={'34px'}
                                            color={headerValue.priceColor ?? 'inherit'}
                                        >
                                            {headerValue.price}
                                        </Text>
                                        {headerValue.crossedPrice && (
                                            <Text
                                                fontSize={'16px'}
                                                lineHeight={'1'}
                                                textDecoration={'line-through'}
                                                margin={'3px 0 0'}
                                            >
                                                {headerValue.crossedPrice}
                                            </Text>
                                        )}
                                        <Text
                                            fontSize={'12px'}
                                            color={'#515151'}
                                            lineHeight={'1.6'}
                                            margin={'5px 0 15px'}
                                        >
                                            {headerValue.priceInfo}
                                        </Text>

                                        <Link
                                            display={'inline-flex'}
                                            alignItems={'center'}
                                            fontWeight={'700'}
                                            href={headerValue.href}
                                        >
                                            <Text
                                                as={'span'}
                                                paddingRight={'10px'}
                                                fontSize={'14px'}
                                            >
                                                {headerValue.linkName}
                                            </Text>
                                            <svg
                                                width="7"
                                                height="10"
                                                viewBox="0 0 9 14"
                                                fill="#171717"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path d="M0 13.6H2.70588L8.4 6.98565L2.70588 0.400024H0L5.69412 6.98565L0 13.6Z" />
                                            </svg>
                                        </Link>
                                    </Box>
                                </StyledBox>

                                <Accordion
                                    allowToggle
                                    allowMultiple={allowMultiple}
                                    index={openAccordions}
                                    onChange={handleAccordionChange}
                                >
                                    {tableSection.map((section, index, array) => {
                                        return (
                                            <AccordionItem key={index}>
                                                <AccordionButton
                                                    padding={'5px 15px'}
                                                    background={'#eeeeee'}
                                                    color={'#171717'}
                                                    fontSize={'18px'}
                                                    fontWeight={'600'}
                                                    justifyContent={'space-between'}
                                                    alignItems={'center'}
                                                    minHeight={'46px'}
                                                >
                                                    <Text
                                                        as="span"
                                                        display="flex"
                                                        flexDirection="column"
                                                        alignItems="flex-start"
                                                        lineHeight="normal"
                                                    >
                                                        {section.category}
                                                        {section.subtitle && (
                                                            <Text
                                                                as="span"
                                                                fontSize="12px"
                                                                fontWeight="400"
                                                            >
                                                                {section.subtitle}
                                                            </Text>
                                                        )}
                                                    </Text>

                                                    <AccordionIcon />
                                                </AccordionButton>
                                                {type && (
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        padding="30px 10px"
                                                    >
                                                        {section.values[type]}
                                                    </Box>
                                                )}
                                                <AccordionPanel padding="0 15px 15px">
                                                    {section.details.map((detail: DetailsInfo) => {
                                                        return (
                                                            <Box 
                                                                //key={detail.name}
                                                            >
                                                                <Flex
                                                                    paddingBottom="15px"
                                                                    alignItems="flex-start"
                                                                >
                                                                    {type && (
                                                                        <Box
                                                                            width="20px"
                                                                            flexShrink="0"
                                                                            marginRight="15px"
                                                                            height="auto"
                                                                        >
                                                                            {detail.values[type] ? (
                                                                                <Box
                                                                                    display="flex"
                                                                                    justifyContent="center"
                                                                                    height="24px"
                                                                                    alignItems="center"
                                                                                >
                                                                                    <CheckIcon
                                                                                        color={
                                                                                            '#1AAC7A'
                                                                                        }
                                                                                        fontSize={
                                                                                            '15px'
                                                                                        }
                                                                                    />
                                                                                </Box>
                                                                            ) : (
                                                                                <Box
                                                                                    display="flex"
                                                                                    justifyContent="center"
                                                                                    height="24px"
                                                                                    alignItems="center"
                                                                                >
                                                                                    <Text
                                                                                        color="#C8C8C8"
                                                                                        fontSize="27px"
                                                                                    >
                                                                                        -
                                                                                    </Text>
                                                                                </Box>
                                                                            )}
                                                                        </Box>
                                                                    )}
                                                                    <Text
                                                                        fontSize="15px"
                                                                        color={(type && !detail.values[type]) ? '#818181' : 'inherit' }
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: DOMPurify.sanitize(detail.name),
                                                                        }}
                                                                    />
                                                                </Flex>
                                                            </Box>
                                                        );
                                                    })}
                                                </AccordionPanel>
                                            </AccordionItem>
                                        );
                                    })}
                                </Accordion>
                            </TabPanel>
                        );
                    })}
                </TabPanels>
            </Tabs>
        </Box>
    );
};
